module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "dg-backdrop",
      "appear": ""
    },
    on: {
      "after-leave": function($event) {
        _vm.animationEnded('backdrop')
      }
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "dg-backdrop"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.animation,
      "appear": ""
    },
    on: {
      "after-leave": function($event) {
        _vm.animationEnded('content')
      }
    }
  }, [(_vm.show) ? _c('div', {
    class: ['dg-container', {
      'dg-container--has-input': (_vm.isHardConfirm || _vm.isPrompt)
    }],
    on: {
      "click": _vm.closeAtOutsideClick
    }
  }, [_c('div', {
    staticClass: "dg-content-cont dg-content-cont--floating"
  }, [_c('div', {
    staticClass: "dg-main-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    class: ['dg-content-body', {
      'dg-content-body--has-title': _vm.messageHasTitle
    }]
  }, [(_vm.messageHasTitle) ? [(_vm.options.html) ? _c('h6', {
    staticClass: "dg-title",
    domProps: {
      "innerHTML": _vm._s(_vm.messageTitle)
    }
  }) : _c('h6', {
    staticClass: "dg-title"
  }, [_vm._v(_vm._s(_vm.messageTitle))])] : _vm._e(), _vm._v(" "), (_vm.options.html) ? _c('div', {
    staticClass: "dg-content",
    domProps: {
      "innerHTML": _vm._s(_vm.messageBody)
    }
  }) : _c('div', {
    staticClass: "dg-content"
  }, [_vm._v(_vm._s(_vm.messageBody))]), _vm._v(" "), (_vm.isHardConfirm || _vm.isPrompt) ? _c('form', {
    staticClass: "dg-form",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitDialogForm($event)
      }
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "for": "dg-input-elem"
    }
  }, [_vm._v(_vm._s(_vm.hardConfirmHelpText))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    ref: "inputElem",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "padding": "5px 15px",
      "font-size": "16px",
      "border-radius": "4px",
      "border": "2px solid #eee"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.options.verification,
      "autocomplete": "off",
      "id": "dg-input-elem"
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dg-content-footer"
  }, [_c(_vm.leftBtnComponent, {
    tag: "button",
    attrs: {
      "loading": _vm.loading,
      "enabled": _vm.leftBtnEnabled,
      "options": _vm.options,
      "focus": _vm.leftBtnFocus
    },
    on: {
      "click": function($event) {
        _vm.clickLeftBtn()
      }
    }
  }, [(_vm.options.html) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.leftBtnText)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.leftBtnText))])]), _vm._v(" "), _c(_vm.rightBtnComponent, {
    tag: "button",
    attrs: {
      "loading": _vm.loading,
      "enabled": _vm.rightBtnEnabled,
      "options": _vm.options,
      "focus": _vm.rightBtnFocus
    },
    on: {
      "click": function($event) {
        _vm.clickRightBtn()
      }
    }
  }, [(_vm.options.html) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.rightBtnText)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.rightBtnText))])]), _vm._v(" "), _c('div', {
    staticClass: "dg-clear"
  })])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2c4e0b92!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/components/dialog-window.vue
// module id = 95
// module chunks = 0